module.exports = __webpack_public_path__ + "assets/media/d-1.e29843be.svg";